<template>
  <div class="leave-request height-100 flex-col pad-10 pad-top-0">

    <b-modal :active.sync="showUserModal">
      <div class="box flex-col" style="max-width: 400px; margin: 0 auto;">
        <div class="font-size-120 bold margin-bottom-5">
          Select User
        </div>
        <b-field grouped expanded>
          <b-field expanded>
            <p class="control has-icons-left">
              <input class="input" v-model="searchStr" placeholder="search users" />
              <span class="icon is-small is-left">
                <fa icon="search" />
              </span>
            </p>
          </b-field>
          <p class="control">
            <button class="button" @click="showUserModal = false"><fa icon="times" /></button>
          </p>
        </b-field>
        <div class="flex-1 overflow-y-auto" style="border: solid 1px #ccc; margin-top: -15px; min-height: 200px; max-height: 50vh">
          <table class="table is-striped is-narrow is-hoverable width-100">
            <tbody>
              <tr v-for="user in filteredUsers" :key="user._id" class="pointer" @click="onSelectUser(user)">
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <div class="bold font-size-150">
      <button v-if="isAdmin" class="button margin-right-10" @click="onEditUser()"><fa icon="edit" /></button>
      <template v-if="selectedUser">{{ selectedUser | name }}</template>
      <template v-else><span class="has-text-grey-light bold">SELECT USER</span></template>
    </div>

    <div class="pad-top-5">
      <template v-if="fromTimestamp && toTimestamp">
        {{ fromTimestamp | unixToDateString }} to {{ toTimestamp  | unixToDateString }}
      </template>
      <template v-else>Select Dates</template>
    </div>

    <div class="dates pad-top">
        <b-datepicker
          :mobile-native="false"
          v-model="dates"
          icon-pack="fas"
          inline
          range
        />
        <div class="pad-10" v-if="isAdmin">
          <b-checkbox v-model="approved">Approve</b-checkbox>
        </div>
        <div class="buttons pad-top-10">
          <button class="button is-info" :class="{'is-loading': submitting}" @click="onSubmitDates()" :disabled="!selectedUser || dates.length !== 2">
            Submit  {{ approved ? 'Approved Leave' : 'Leave Request' }}
          </button>
          <button class="button" @click="$emit('close')">Cancel</button>
        </div>
    </div>

    <br />
    <br />
    <br />

  </div>
</template>

<script>
export default {
  data () {
    return {
      dates: [],
      users: null,
      selectedUser: null,
      showUserModal: false,
      searchStr: '',
      approved: false,
      submitting: false,
      fromTimestamp: 0,
      toTimestamp: 0
    }
  },
  watch: {
    dates () {
      this.fromTimestamp = this.$moment(this.dates[0]).unix()
      this.toTimestamp = this.$moment(this.dates[1]).unix()
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    canTakeLeave () { return this.user && this.user.privileges.includes('leave') },
    isAdmin () { return this.user && this.user.privileges.includes('leave admin') },
    filteredUsers () {
      if (!this.users) return []
      let str = this.searchStr.trim().toLowerCase()
      return this.users.filter(user => user.name.toLowerCase().indexOf(str) >= 0)
    }
  },
  created () {
    if (this.canTakeLeave) {
      this.selectedUser = this.user
    }
    if (this.isAdmin) {
      this.subs.users = this.$fs.collection('users')
        .where('privileges', 'array-contains', 'leave')
        .onSnapshot(snapshot => {
          let users = this.$utils.snapshotToArr(snapshot)
            .map(user => {
              return {
                _id: user._id,
                firstName: user.firstName,
                lastName: user.lastName,
                name: `${user.firstName} ${user.lastName}`
              }
            })
          this.users = users
        })
    }
  },
  methods: {
    onEditUser () {
      this.searchStr = ''
      this.showUserModal = true
    },
    onSelectUser (user) {
      this.selectedUser = user
      this.showUserModal = false
    },
    async onSubmitDates () {
      this.submitting = true
      let leave = {
        user: {
          _id: this.selectedUser._id,
          firstName: this.selectedUser.firstName,
          lastName: this.selectedUser.lastName
        },
        approved: this.approved,
        requestedTimestamp: this.$moment().unix(),
        fromTimestamp: this.$moment(this.dates[0]).startOf('day').unix(),
        toTimestamp: this.$moment(this.dates[1]).startOf('day').unix(),
        months: this.getMonths()
      }
      await this.$fs.collection('leave').add(leave)
      this.submitting = false
      this.$emit('close', leave)
    },
    getMonths () {
      let months = []
      let m = this.$moment(this.dates[0]).startOf('day')
      let toTimestamp = this.$moment(this.dates[1]).startOf('day').unix()
      let timestamp = m.unix()
      while (timestamp <= toTimestamp) {
        months.push(m.month())
        m.add(1, 'month')
        timestamp = m.unix()
      }
      return months
    }
  }
}
</script>
